import { createContext } from 'react';

export const ErrorsContext = createContext<unknown[] | undefined>(undefined);
ErrorsContext.displayName = 'ErrorsContext';
